// params object
export const params = {
	// year
	year: 2020,

	// available languages
	languages: [
		['ru', 'Русский', 3],
		['en', 'English', 7]
	],

	languageDefault: 'ru',

	// social buttons
	socialButtons: [
		['buttonsSite', 'https://wogames.info', 'fab fa-edge'],
		['buttonTeamspeak', 'ts3server://wogames.info?port=9987', 'fab fa-teamspeak'],
		['buttonTwitter', 'https://twitter.com/weeklyopengames', 'fab fa-twitter'],
		['buttonSteam', 'https://steamcommunity.com/groups/WeeklyOpenGames', 'fab fa-steam-symbol'],
		['buttonVk', 'https://vk.com/weeklyopengames', 'fab fa-vk'],
		['buttonDiscord', 'https://discord.gg/wp4c3WHs', 'fab fa-discord']
	],

	// images gallery
	gallery: [
		['galleryTitle01', 'galleryDescription01', '1600x900', '/static/images/portfolio/gallery/g-fog.jpg', '/static/images/portfolio/fog.jpg', '/static/images/portfolio/fog@2x.jpg'],
		['galleryTitle02', 'galleryDescription02', '1600x900', '/static/images/portfolio/gallery/g-mountains.jpg', '/static/images/portfolio/mountains.jpg', '/static/images/portfolio/mountains@2x.jpg'],
		['galleryTitle03', 'galleryDescription03', '1600x900', '/static/images/portfolio/gallery/g-east.jpg', '/static/images/portfolio/east.jpg', '/static/images/portfolio/east@2x.jpg'],
		['galleryTitle04', 'galleryDescription04', '1600x900', '/static/images/portfolio/gallery/g-pakfa.jpg', '/static/images/portfolio/pakfa.jpg', '/static/images/portfolio/pakfa@2x.jpg'],
		['galleryTitle05', 'galleryDescription05', '1600x900', '/static/images/portfolio/gallery/g-chechnia.jpg', '/static/images/portfolio/chechnia.jpg', '/static/images/portfolio/chechnia@2x.jpg'],
		['galleryTitle06', 'galleryDescription06', '1600x900', '/static/images/portfolio/gallery/g-tank.jpg', '/static/images/portfolio/tank.jpg', '/static/images/portfolio/tank@2x.jpg']
	],

	videos: [
		[0, 'Day on Weekly Open Games 6', '[LG] Madness', 'https://www.youtube.com/channel/UCyKbZgGKG9fUATFlAIe9_ww', 'https://www.youtube.com/watch?v=5dxfzy_INJ4'],
		[1, 'Day on Weekly Open Games 5', '[LG] Madness', 'https://www.youtube.com/channel/UCyKbZgGKG9fUATFlAIe9_ww', 'https://www.youtube.com/watch?v=ZXP3ngSPOsc'],
		[2, 'WOG Moments 31', 'Makaveli', 'https://www.youtube.com/channel/UCU4bYKRXtTlRW_2q-AIYM_Q', 'https://www.youtube.com/watch?v=SSUjMze1TpA&list=PLPYXn2YclVrQFTEop8wuZ_PKG2KmKRYCE&index=0'],
		[3, 'WOG Moments 30', 'Makaveli', 'https://www.youtube.com/channel/UCU4bYKRXtTlRW_2q-AIYM_Q', 'https://www.youtube.com/watch?v=oTsGQbdUqvY&list=PLPYXn2YclVrQFTEop8wuZ_PKG2KmKRYCE&index=1'],
		[4, 'WOG Moments 29', 'Makaveli', 'https://www.youtube.com/channel/UCU4bYKRXtTlRW_2q-AIYM_Q', 'https://www.youtube.com/watch?v=oxJ1EdOyHpA&list=PLPYXn2YclVrQFTEop8wuZ_PKG2KmKRYCE&index=2'],
		[5, 'WOG Moments 28', 'Makaveli', 'https://www.youtube.com/channel/UCU4bYKRXtTlRW_2q-AIYM_Q', 'https://www.youtube.com/watch?v=zZd5o9is3u4&list=PLPYXn2YclVrQFTEop8wuZ_PKG2KmKRYCE&index=3'],
		// [3, 'WOG Moments 27', '[OSN] Makaveli', 'https://www.youtube.com/channel/UCU4bYKRXtTlRW_2q-AIYM_Q', 'https://www.youtube.com/watch?v=pYZmvALfqrc&list=PLPYXn2YclVrQFTEop8wuZ_PKG2KmKRYCE&index=3'],
		// [4, 'WOG Moments 26', '[OSN] Makaveli', 'https://www.youtube.com/channel/UCU4bYKRXtTlRW_2q-AIYM_Q', 'https://www.youtube.com/watch?v=iz1NyJbfjBw&list=PLPYXn2YclVrQFTEop8wuZ_PKG2KmKRYCE&index=4'],
		// [5, 'WOG Moments 25', '[OSN] Makaveli', 'https://www.youtube.com/channel/UCU4bYKRXtTlRW_2q-AIYM_Q', 'https://www.youtube.com/watch?v=5icZyII-t_g&list=PLPYXn2YclVrQFTEop8wuZ_PKG2KmKRYCE&index=5'],
	],

	quotes: [
		['quotesQuote1', '[FFA]Shullman', 'https://wogames.info/uploads/monthly_2017_10/maxresdefault.thumb.jpg.f1ac9316a8adf1a79e57cf12bbf77ea9.jpg'],
		['quotesQuote2', '5thPK_Punisher', 'https://wogames.info/uploads/monthly_2017_06/adam.thumb.jpg.c9cfbc7e9f9e7bf101aedb1770301631.jpg'],
		['quotesQuote3', '[RE]Harex', 'https://cdn0.iconfinder.com/data/icons/flat-design-business-set-3/24/people-customer-unknown-512.png'],
		['quotesQuote4', 'Makaveli', 'https://wogames.info/uploads/monthly_2017_12/1366476437295.thumb.jpg.a1962019f902761c16cdfb9b7d3dcd9f.jpg'],
		['quotesQuote5', '[DT]Heavy', 'https://wogames.info/uploads/profile/photo-thumb-32.jpg'],
		['quotesQuote6', '[FOX]GW', 'https://cdn0.iconfinder.com/data/icons/flat-design-business-set-3/24/people-customer-unknown-512.png'],
		['quotesQuote7', '-[SF]- Russ Ivan', 'https://wogames.info/uploads/monthly_2017_06/59369b1e013b2_.thumb.gif.abf6d0a2821854265ab9def9ec967682.gif'],
		['quotesQuote8', '[DT]Toshka', 'https://wogames.info/uploads/monthly_2016_10/53.jpg.da44c61a4d74c1cafa98659489122393.thumb.jpg.f6d355d817890b02e625482c8a7c7851.jpg'],
		['quotesQuote9', 'MOHAX', 'https://cdn0.iconfinder.com/data/icons/flat-design-business-set-3/24/people-customer-unknown-512.png'],
		['quotesQuote10', '[FFA]Shullman', 'https://wogames.info/uploads/monthly_2017_10/maxresdefault.thumb.jpg.f1ac9316a8adf1a79e57cf12bbf77ea9.jpg']
	]
};



// WEBPACK FOOTER //
// ./src/params.js